<template>
  <div>
    <!-- <v-expansion-panels
      flat
      class="py-0 my-0 ps-md-3 pe-md-3"
      v-model="panel"
      multiple
    >
      <v-expansion-panel class="my-5 px-0 mx-0" v-for="(item, index) in expansionPanels" :key="index">
        <v-expansion-panel-header class="custom-font">
          <template v-slot:actions>
            <v-icon color="primary"> mdi-chevron-down </v-icon>
          </template>
          <v-container fluid>
            <v-row class="justify-space-between ma-0">
              <h3 class="custom-subtitle">
                {{ $t(item.title) }}
              </h3>
              <v-btn @click.native.stop v-if="item.btnTitle" class="custom-button text-none" @click="showRightSideDrawer(item.table)" depressed small>
                <v-icon size="20" left>mdi-plus</v-icon>
                {{ $t(item.btnTitle) }}
              </v-btn>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="item.table === 'CUSTOMER'"><customer-data-table/></template>
          <template v-if="item.table === 'OTP'"><otp-data-table/></template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->
    <customer-data-table/>
    <side-drawer>
      <template slot="formDetails">
        <customer-form/>
      </template>
    </side-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      // panel: [0, 1]
    }
  },
  components: {
    "side-drawer": () => import("@/core/components/SideDrawer"),
    'customer-data-table': () => import("@/user/components/customer/UserDataTable.vue"),
    // 'otp-data-table': () => import("@/user/components/customer/OtpDataTable.vue"),
    'customer-form': () => import("@/user/components/rightSideDrawer/CustomerForm.vue")
  },
  computed: {
    ...mapGetters(['customerFormName']),
    // expansionPanels () {
    //   return [
    //     { title: 'layout.user', btnTitle: false, table: 'CUSTOMER' },
    //     { title: 'customer.otp.otp', btnTitle: false, table: 'OTP' }
    //   ]
    // }
  },
  methods: {
    showRightSideDrawer () {
      this.$store.commit('SHOW_RIGHTSIDE_DRAWER', true)
      // this.$store.commit('CUSTOMER_FORMNAME', item)
    }
  }
}
</script>

<style>

</style>